import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from './Icon';
export const IconContrast = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="ultimate">
      <Path d="M12 3.5c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Zm.827 16.3V5.2c3.663.412 6.52 3.529 6.52 7.3s-2.857 6.888-6.52 7.3Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
